export const getUltimos = async () => {
  const resp = await fetch(
    `${process.env.REACT_APP_API_URL}/ultimos`
  );
  const data = await resp.json();
  return data;
};
